import React, { Component } from "react";
import "./ImportCalendarEvents.css";
import {
    Link,
    Redirect
  } from "react-router-dom";
import moment from "moment";
import Papa from "papaparse";

class ImportCalendarEvents extends Component {
  constructor(props) {
    super(props);
    this.state = {
        redirect: false,
        data : null
    };
    this.handleClose = this.handleClose.bind(this);
    this.createEventsFromImportedData = this.createEventsFromImportedData.bind(this);
    this.importEventsAsCSV = this.importEventsAsCSV.bind(this);
    this.readCsvFile = this.readCsvFile.bind(this);
    this.confirmInport = this.confirmInport.bind(this);
  }

  createEventsFromImportedData(eventsArray){
    console.log('importEventsAsCSV',eventsArray);
    let EVENTS_DATA=eventsArray;
    let count=0;
    let UPDATED_EVENTS = eventsArray.map((item)=>{
      count++;
      let description = `
  Platz : ${item.Platz}
  SpielForm : ${item.SpielForm}
  Teilnehmer : ${item.Teilnehmer}
  Spielleitung : ${item.Spielleitung}
  Vorgabe : ${item.Vorgabe.replace('#ERROR!','+')}
  Bemerkungen : ${item.Bemerkungen}
  Kommentare : ${item.Kommentare}
  
      `;
      let startDate=item.Datum + ' '+item.Zeit;
      //console.log("startDate 1: ",startDate);
      startDate=startDate.replace('*','');
      startDate = startDate.replace('.','/');
      startDate = startDate.replace('.','/');
      //console.log("startDate 2: ",startDate);
      startDate= moment(startDate,'DD-MM-YY HH:mm');
      console.log("startDate 3: ",startDate);
      console.log("startDate ISO ",startDate.toISOString());
      let newEvent = {
        id: moment().unix(),
        title: "Seniorenkreis Nr."+count,
        description: description,
        duration: 2,
        createdBy: this.props.user.email,
        participants: [this.props.user.email],
        startDate: startDate,
        end: moment(startDate)
          .add(3, "hours")
          .toDate()
          .toISOString(), 
        color: 'blue'
      };
      return newEvent;
    });

    //console.table(UPDATED_EVENTS);
    return UPDATED_EVENTS;
  }

  importEventsAsCSV(csvStr) {
    console.log('importEventsAsCSV');
    let options={
      header : true
    };
    let parsedData = Papa.parse(csvStr,options);
   //console.table(parsedData.data);
    let eventsList = this.createEventsFromImportedData(parsedData.data);
    console.log('importEventsAsCSV',eventsList);
    this.props.onImportEventsData(eventsList);
    this.handleClose();
  }
  
  readCsvFile(event){
     console.log("readCsvFile",event); 
     let file = event.target.files[0];
     console.log("readCsvFile file" ,file); 
     if (!file) return;
     let reader = new FileReader();
     reader.onload =(e)=>{
       let contents = e.target.result;
            console.log("readCsvFile onLoad contents",this.importEventsAsCSV); 
            this.setState({
                data : contents
            });
           
     };
     reader.readAsText(file);
  }
  confirmInport(){
    this.importEventsAsCSV(this.state.data);
    //this. handleClose();
  }

  handleClose() {
    console.log("EventUpdate : handleClose()");
   // this.props.onClose();
    this.setState({ redirect: true });
  }

  render() {
    return this.state.redirect ? (
      <Redirect to="/" />
    ) : ( <div className="modal is-active">
        <div onClick={this.handleClose} className="modal-background"></div>
        <div className="modal-content">
        <div className="box has-shadow">
        <h2>Daten Importieren</h2>
        <p>So gehts: <br/>Bitte Daten aus Excel als CSV File Format exportieren und hier laden. Dann Import bestätigen!</p>
        <div className="field">
                <div className="control">
                    <label htmlFor="">CSV Daten ( copy paste) </label>
                    <input className="input" type="file" id="file-input" onChange={this.readCsvFile} />
                </div>
                <div className="output">
                    <h3>Contents of the file:</h3>
                    <pre id="file-content">
                    {this.state.data}</pre>
                </div>
                <div>
                    <button className="button" onClick={this.confirmInport}>JETZT IMPORTIEREN!</button>
                </div>
            </div>
        </div>

        </div>
    </div>)
}

}

export default ImportCalendarEvents;


// WEBPACK FOOTER //
// ./src/ImportCalendarEvents.js